import { makeSelectors } from '@utils/css';

const button = "dibbwokgf5";
const contentWrapper = "dibc1sr436z";
const icon = "dibi1q57q86";
const label = "dibl1d7wmj";
const spinner = "dibs17ynfty";
const selectors = makeSelectors({
  contentWrapper,
  icon,
  label
});

export { button, contentWrapper, icon, label, selectors, spinner };
import "./button.style.linaria.module.css";
//# sourceMappingURL=button.style.js.map
